module.exports = __webpack_public_path__ + "img/6.ffbec3a5.webp";